import { render, staticRenderFns } from "./WaybillReceivable.vue?vue&type=template&id=1de97b4b&scoped=true&"
import script from "./WaybillReceivable.vue?vue&type=script&lang=js&"
export * from "./WaybillReceivable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de97b4b",
  null
  
)

export default component.exports